module.exports = __webpack_public_path__ + "img/MN.1ad126fc.png";